


































import CategoryBubbles from "@/components/CategoryBubbles.vue";
import Vue from "vue";
export default Vue.extend({
  name: "Homepage",
  components: { CategoryBubbles },
  computed: {
    getStylesWelcomeMessage() {
      if (this.message === "There are no results for this search...") {
        return {
          /*"font-size": "4rem",
          "font-weight": "bold",
          color: "#20273E",*/
        };
      } else {
        return {
          "font-size": "2rem",
          color: "#544e9c",
        };
      }
    },
  },
  props: {
    message: String,
  },
});
